import { lazy } from "react";
import MainLayout from "../Components/MainLayout";

const Home = lazy(() => import("../Pages/Home"));
const About = lazy(() => import("../Pages/About"));
const Contacts = lazy(() => import("../Pages/Contacts"));
const Error = lazy(() => import("../Pages/Error"));
const PrivateTours = lazy(() => import("../Pages/PrivateTours"));
const TopTours = lazy(() => import("../Pages/TopTours"));
const TourCars = lazy(() => import("../Pages/TourCars"));
const Dashboard = lazy(() => import("../Pages/Dashboard"));
const Reviews = lazy(() => import("../Pages/Reviews"));


const UserLogin = lazy(() => import("../Pages/Auth/Login"));
const UserRegister = lazy(() => import("../Pages/Auth/Register"));
const OAuthCallback = lazy(() => import("../Pages/Auth/OAuthCallback"));
const VerifyEmail = lazy(() => import("../Pages/Auth/VerifyEmail"));

const ReviewApprovals = lazy(() => import("../Pages/Admin/Reviews"));
const TourManagement = lazy(() => import("../Pages/Admin/Tours"));
const CarManagement = lazy(() => import("../Pages/Admin/Cars"));
const AdminBookings = lazy(() => import("../Pages/Admin/Bookings"));
const AdminUsers = lazy(() => import("../Pages/Admin/Users"));
const AdminLogin = lazy(() => import("../Pages/Admin/Login"));
const AdminLayout = lazy(() => import("../Components/Admin/AdminLayout"));

export const routerLists = [
  // Public Routes with Main Header/Footer
  {
    path: "/",
    element: <MainLayout />,
    id: 1,
    children: [
      {
        path: "/",
        name: "Home",
        element: <Home />,
        id: 11,
      },
      {
        path: "/private-tours",
        name: "PrivateTours",
        element: <PrivateTours />,
        id: 4,
      },
      {
        path: "/top-tours/:id",
        name: "TourPackages",
        element: <TopTours/>,
        id: 55,
      },
      {
        path: "/about",
        name: "About",
        element: <About />,
        id: 6,
      },
      {
        path: "/contacts",
        name: "Contacts",
        element: <Contacts />,
        id: 7,
      },
      {
        path: "/tour-cars",
        name: "TourCars",
        element: <TourCars />,
        id: 77,
      },
      {
        path: "/dashboard",
        name: "Dashboard",
        element: <Dashboard />,
        id: 78,
      },
      {
        path: "/reviews",
        name: "Reviews",
        element: <Reviews />,
        id: 79,
      },
    ]
  },

  // User Auth (Standalone, no header/footer)
  {
    path: "/auth/login",
    name: "UserLogin",
    element: <UserLogin />,
    id: 20,
  },
  {
    path: "/auth/register",
    name: "UserRegister",
    element: <UserRegister />,
    id: 21,
  },
  {
    path: "/auth/callback",
    name: "OAuthCallback",
    element: <OAuthCallback />,
    id: 22,
  },
  {
    path: "/auth/verify-email",
    name: "VerifyEmail",
    element: <VerifyEmail />,
    id: 23,
  },
  
  // Standalone Admin Login
  {
    path: "/admin/login",
    name: "AdminLogin",
    element: <AdminLogin />,
    id: 9,
  },

  // Protected Admin Section
  {
    path: "/admin",
    element: <AdminLayout />,
    id: 10,
    children: [
      {
        path: "reviews",
        name: "ReviewApprovals",
        element: <ReviewApprovals />,
        id: 111,
      },
      {
        path: "tours",
        name: "TourManagement",
        element: <TourManagement />,
        id: 112,
      },
      {
        path: "cars",
        name: "CarManagement",
        element: <CarManagement />,
        id: 113,
      },
      {
        path: "bookings",
        name: "AdminBookings",
        element: <AdminBookings />,
        id: 28,
      },
      {
        path: "users",
        name: "AdminUsers",
        element: <AdminUsers />,
        id: 29,
      },
    ]
  },

  // Error Page (Standalone)
  {
    path: "*",
    name: "Error",
    element: <Error />,
    id: 8,
  },
];
